exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".manage-mode-inner-wrapper{padding:20px 20px 20px 200px}.manage-mode-inner-wrapper h2,.manage-mode-inner-wrapper h3{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/PageLayout/Manage/index.scss
// module id = 1018
// module chunks = 0